var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCicd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cicd") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9,24a2,2,0,0,1,2,2.2A22,22,0,0,1,24,46,22.3,22.3,0,0,1,8.4,39.6L6.7,41.3A1,1,0,0,1,5,40.6V29H16.6a1,1,0,0,1,.7,1.7l-1.8,1.8a12,12,0,0,0,20.4-6.8,2,2,0,0,1,2-1.7h0a2,2,0,0,1,1.9,2.3,16,16,0,0,1-27.1,9l-1.4,1.4A17.6,17.6,0,0,0,24,42,18,18,0,0,0,41.9,25.8a2,2,0,0,1,2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,7.4V19H31.4a1,1,0,0,1-.7-1.7l1.8-1.8a12,12,0,0,0-20.4,6.8,2,2,0,0,1-2,1.7h0a2,2,0,0,1-1.9-2.3,16,16,0,0,1,27.1-9l1.4-1.4A17.6,17.6,0,0,0,24,6,18,18,0,0,0,6.1,22.2a2,2,0,0,1-2,1.8h0a2,2,0,0,1-2-2.2A22,22,0,0,1,24,2,22.3,22.3,0,0,1,39.6,8.4l1.7-1.7A1,1,0,0,1,43,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,22a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-4a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCicd);
export default __webpack_public_path__ + "static/media/cicd.398b543384faed1f2cc721d5441a06af.svg";
export { ForwardRef as ReactComponent };